import { useLingui } from "@lingui/react";
import FieldValuePair from "../../FieldValuePair.tsx";
import type { SpecProps } from "./../types.ts";

export const Tyres = ({ tyres }: SpecProps<"tyres">) => {
  const { i18n } = useLingui();

  if (tyres == null) {
    return null;
  }

  const tyresFront = i18n.t({
    id: "itemPageLayout.keyInfo.tyres.front",
    message: "Tyres front",
    comment: "Field for 'tyres front' in ad specification",
  });

  const tyresBack = i18n.t({
    id: "itemPageLayout.keyInfo.tyres.back",
    message: "Tyres back",
    comment: "Field for 'tyres back' in ad specification",
  });

  return (
    <>
      <FieldValuePair field={tyresFront} value={tyres.front} />
      <FieldValuePair field={tyresBack} value={tyres.rear} />
    </>
  );
};
